import { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import {
  getLocationAddress,
  isMatchedLocation,
  selectAllServiceLocations,
} from '@user/store/entityLocations'

export type MenuOption = {
  value: number
  label: string
}

export function useMatchedServiceLocationsSelector() {
  const serviceLocations = useSelector(selectAllServiceLocations)

  const matchedLocations = useMemo(
    () => serviceLocations.filter(isMatchedLocation),
    [serviceLocations],
  )

  const isMatched = matchedLocations.length > 0

  const menuOptions: MenuOption[] = useMemo(
    () =>
      matchedLocations.map((l) => ({
        value: l.id,
        label: `${l.locationCode} - ${getLocationAddress(l)}`,
      })),
    [matchedLocations],
  )

  const [selectedLocation, setSelectedLocation] = useState(() =>
    [...matchedLocations].shift(),
  )

  const onChangeSelectedLocation = useCallback(
    (option: MenuOption) => {
      setSelectedLocation(
        matchedLocations.find((x) => x.id === Number(option.value)),
      )
    },
    [matchedLocations],
  )

  return {
    isMatched,
    menuOptions,
    selectedLocation,
    onChangeSelectedLocation,
  }
}
